<dx-tabs [scrollingEnabled]="true" [scrollByContent]="true" [dataSource]="navItems" [showNavButtons]="true"
    [(selectedIndex)]="rfq.indexItem" class="item-list-tab">
</dx-tabs>